import { render, staticRenderFns } from "./IdConf.vue?vue&type=template&id=129a13cd&scoped=true&"
import script from "./IdConf.vue?vue&type=script&lang=js&"
export * from "./IdConf.vue?vue&type=script&lang=js&"
import style0 from "./IdConf.vue?vue&type=style&index=0&id=129a13cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a13cd",
  null
  
)

export default component.exports